// extracted by mini-css-extract-plugin
export default {"container":"user-sidebar_container__ngwVq","image":"user-sidebar_image__E03T+"};